import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/BookDemo.css';
import { useTranslation } from 'react-i18next';

const BookDemo = ({ onClose }) => {
  const { t } = useTranslation();
  const form = useRef();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormError(null);
    
    // Get form data
    const formData = {
      name: form.current.querySelector('input[name="name"]').value,
      email_address: form.current.querySelector('input[name="email_address"]').value,
      company: form.current.querySelector('input[name="company"]').value || '',
      message: form.current.querySelector('textarea[name="message"]').value
    };
    
    // Send email using EmailJS - exact format from example
    emailjs.send("service_1dds2uc", "template_g7uiiml", formData, "gSvPoWeQ3JqzuuqSG")
      .then((result) => {
        setIsSubmitted(true);
        setIsSubmitting(false);
        form.current.reset();
      }, (error) => {
        console.error('Email send error:', error);
        setFormError(t('bookDemo.form.error'));
        setIsSubmitting(false);
      });
  };

  return (
    <div className="book-demo-overlay">
      <div className="book-demo-container">
        <div className="book-demo-header">
          <h2>{t('bookDemo.title')}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        {isSubmitted ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h3>{t('bookDemo.success.title')}</h3>
            <p>{t('bookDemo.success.message')}</p>
            <button className="book-demo-button" onClick={onClose}>{t('bookDemo.success.close')}</button>
          </div>
        ) : (
          <form ref={form} onSubmit={sendEmail} className="book-demo-form">
            <div className="form-group">
              <label>{t('bookDemo.form.name')}</label>
              <input 
                type="text" 
                name="name" 
                className="contact__form-input"
                placeholder={t('bookDemo.form.namePlaceholder')} 
                required 
              />
            </div>

            <div className="form-group">
              <label>{t('bookDemo.form.email')}</label>
              <input 
                type="email" 
                name="email_address" 
                className="contact__form-input"
                placeholder={t('bookDemo.form.emailPlaceholder')} 
                required 
              />
            </div>

            <div className="form-group">
              <label>{t('bookDemo.form.company')}</label>
              <input 
                type="text" 
                name="company" 
                className="contact__form-input"
                placeholder={t('bookDemo.form.companyPlaceholder')} 
              />
            </div>

            <div className="form-group">
              <label>{t('bookDemo.form.message')}</label>
              <textarea 
                name="message" 
                cols="30" 
                rows="4"
                className="contact__form-input" 
                placeholder={t('bookDemo.form.messagePlaceholder')} 
                required
              ></textarea>
            </div>

            {formError && <div className="error-message">{formError}</div>}

            <button 
              type="submit" 
              className="book-demo-button button button--flex"
              disabled={isSubmitting}
            >
              {isSubmitting ? t('bookDemo.form.sending') : t('bookDemo.form.submit')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default BookDemo; 